import React from "react";

interface CategoryType {
  id: number;
  name: string;
}

interface ProductCategoryTabProps {
  assignedListingCategories: number[]; // sub categories / listing categories
  listingCategories: CategoryType[];
  toggleListingCategory: (id: number) => void;

  isEdit: boolean;
  onUpdate?: () => void;
  isLoading?: boolean;
}

export const ProductCategoryTab: React.FC<ProductCategoryTabProps> = ({
  assignedListingCategories,
  listingCategories,
  toggleListingCategory,
  isEdit,
  onUpdate,
  isLoading,
}) => {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="mt-2">
          <label className="block text-sm text-[#3F5260] font-medium mb-3">
            Listing Categories
          </label>
          {listingCategories.length === 0 ? (
            <p className="text-sm text-gray-500">No listing categories available.</p>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
              {listingCategories.map((category) => {
                const isSelected = assignedListingCategories.includes(category.id);
                return (
                  <label
                    key={category.id}
                    className={`flex items-center p-3 border rounded-lg cursor-pointer transition-colors ${isSelected
                        ? "border-emerald-500 bg-emerald-50 text-emerald-700"
                        : "border-gray-200 hover:border-gray-300"
                      }`}
                  >
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => toggleListingCategory(category.id)}
                      className="w-4 h-4 text-emerald-600 rounded focus:ring-emerald-500 border-gray-300 mr-3"
                    />
                    <span className="text-sm font-medium">{category.name}</span>
                  </label>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {isEdit && (
        <div className="flex justify-end mt-6">
          <button
            type="button"
            onClick={onUpdate}
            disabled={isLoading}
            className="px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition"
          >
            {isLoading ? "Updating..." : "Update Categories"}
          </button>
        </div>
      )}
    </div>
  );
};
